import axios from './axiosConfig.js'

export const getAllBlogs = async () => {
  const response = await axios.get('/blog')
  // console.log('blog data', response.data)
  return response.data
}

export const getBlogById = async (id) => {
  const response = await axios.get(`/blog/${id}`)
  console.log('response blog at api', response.data)
  return response.data
}

export const createBlog = async (formData) => {
  console.log('creating formdata:', formData)
  const data = new FormData()
 
  // Required fields
  data.append('title', formData.title)
  data.append('description', formData.description)
  data.append('articleDate', formData.articleDate)
  data.append('brandName', formData.brandName)
  data.append('writtenBy', formData.writtenBy || '')
  data.append('pcCredit', formData.pcCredit || '')
  data.append('categoryId', +formData.categoryId || '')
  data.append('showInSlider', !!formData.showInSlider)

  // File uploads - required for create
  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  console.log('creating blog with FormData:')
  // Log FormData contents for debugging
  for (let [key, value] of data.entries()) {
    console.log(`${key}:`, value)
  }

  try {
    const response = await axios.post('/blog', data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error creating blog:', error)
    throw error
  }
}

export const updateBlog = async (id, formData) => {
  // console.log('updating formData', formData)

  const data = new FormData()

  // Required fields - always append these
  data.append('title', formData.title || '')
  data.append('articleDate', formData.articleDate || '')
  data.append('description', formData.description || '')
  data.append('categoryId', +formData.categoryId || '')

  data.append('brandName', formData.brandName || '')
  data.append('writtenBy', formData.writtenBy || '')
  data.append('pcCredit', formData.pcCredit || '')
  data.append('showInSlider', !!formData.showInSlider)

  // File uploads - only append if new files are selected
  if (formData.image && formData.image[0]) {
    data.append('image', formData.image[0])
  }

  // console.log('Updating blog with FormData:')
  // Log FormData contents for debugging
  // for (let [key, value] of data.entries()) {
  //   console.log(`${key}:`, value)
  // }

  try {
    const response = await axios.put(`/blog/${id}`, data, {
      withCredentials: true,
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    return response.data
  } catch (error) {
    console.error('Error updating deal:', error)
    throw error
  }
}

export const deleteBlog = async (id, otp) => {
  try {
    const response = await axios.delete(`/blog/${id}?otp=${otp}`, {
      withCredentials: true,
    })

    console.log('Delete blog response:', response)
    return response.data
  } catch (error) {
    console.error('Error deleting blog:', error)
    const errorMessage =
      error?.response?.data?.message ||
      error?.message ||
      'Failed to delete blog'
    throw new Error(errorMessage)
  }
}

export const sendBlogMail = async (id) => {
  console.log('sendMail: data:', id)
  try {
    const response = await axios.get(`/blog/mail/${id}`, {
      withCredentials: true,
    })

    console.log('mail API response type:', response)
    return response
  } catch (error) {
    console.error('Error fetching sliders:', error)
    throw error
  }
}
